import { render, staticRenderFns } from "./Comprometimentos.vue?vue&type=template&id=63177e6d"
import script from "./Comprometimentos.vue?vue&type=script&lang=js"
export * from "./Comprometimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports